<template>
<div class="">

  <section class="text_page no_banner_page clearfix">
    <div class="container">
      <div class="row clearfix">
        <div class="main col-lg-8 col-md-12 col-xs-12">
          <h1 class="cat_title">{{ pageData.title }}</h1>
          <div class="text run-text" v-html="pageData.post_content"></div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
  export default {
    data() {
      return {
        title: "",
        content: "",
        page: ""
      };
    },
    computed: {
      pageData(){
        if(typeof wpData.pageData != 'object' ){
          return JSON.parse(wpData.pageData);
        }
        return wpData.pageData;
      }
    },
    beforeCreate() {
     
    },
    created() {
      this.$modal.hide("login-modal");
      /*this.$ajax
                .get(
                  homeUrl +
                    "wp-json/wp/v2/pages?slug=" +
                    encodeURI(this.$route.params.slug)
                )
                .then(reponse => {
                  this.title = reponse.data[0].title.rendered;
                  this.content = reponse.data[0].content.rendered;
                });*/
    }
  };
</script>
